import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { RequireAuth, RequireRole } from './Components/common/ProtectedRoute';
import { ROLES } from './Constants/enums';

// Public
import Login from './Pages/Auth/Login';
import OnboardingForm from './Pages/Public/OnboardingForm';
import PaymentSuccess from './Pages/Public/PaymentSuccess';
import PaymentCancelled from './Pages/Public/PaymentCancelled';

// Shell
import RoleHome from './Pages/common/RoleHome';
import NotFound from './Pages/common/NotFound';

// PlatformAdmin
import AdminUsers from './Pages/PlatformAdmin/AdminUsers';

// CIO
import CioDashboard from './Pages/CIO/CioDashboard';
import Invitations from './Pages/CIO/Invitations';
import Customers from './Pages/CIO/Customers';
import CustomerDetail from './Pages/CIO/CustomerDetail';
import Support from './Pages/CIO/Support';
import TicketDetail from './Pages/CIO/TicketDetail';

// CFO
import CfoDashboard from './Pages/CFO/CfoDashboard';
import PricingPlans from './Pages/CFO/PricingPlans';
import Invoices from './Pages/CFO/Invoices';
import InvoiceDetail from './Pages/CFO/InvoiceDetail';

const CIO_ROLES = [ROLES.CIO, ROLES.PLATFORM_ADMIN];
const CFO_ROLES = [ROLES.CFO, ROLES.PLATFORM_ADMIN];
const PLATFORM_ROLES = [ROLES.PLATFORM_ADMIN];
const SUPPORT_ROLES = [ROLES.CIO, ROLES.PLATFORM_ADMIN, ROLES.SUPPORT];

const AppRoutes = () => (
  <Routes>
    {/* Public routes - no authenticated administration shell */}
    <Route path="/login" element={<Login />} />
    <Route path="/onboarding/:token" element={<OnboardingForm />} />
    <Route path="/billing/payment-success" element={<PaymentSuccess />} />
    <Route path="/billing/payment-cancelled" element={<PaymentCancelled />} />

    {/* Authenticated administration shell */}
    <Route element={<RequireAuth />}>
      <Route index element={<RoleHome />} />

      {/* Platform Administration */}
      <Route element={<RequireRole roles={PLATFORM_ROLES} />}>
        <Route path="/admin" element={<Navigate to="/admin/users" replace />} />
        <Route path="/admin/users" element={<AdminUsers />} />
      </Route>

      {/* CIO Operations (PlatformAdmin may enter) */}
      <Route element={<RequireRole roles={CIO_ROLES} />}>
        <Route path="/cio" element={<CioDashboard />} />
        <Route path="/cio/invitations" element={<Invitations />} />
        <Route path="/cio/customers" element={<Customers />} />
        <Route path="/cio/customers/:id" element={<CustomerDetail />} />
      </Route>

      {/* Tech Support — CIO, PlatformAdmin, and Support agents */}
      <Route element={<RequireRole roles={SUPPORT_ROLES} />}>
        <Route path="/cio/support" element={<Support />} />
        <Route path="/cio/support/:id" element={<TicketDetail />} />
      </Route>

      {/* CFO Finance (PlatformAdmin may enter) */}
      <Route element={<RequireRole roles={CFO_ROLES} />}>
        <Route path="/cfo" element={<CfoDashboard />} />
        <Route path="/cfo/pricing-plans" element={<PricingPlans />} />
        <Route path="/cfo/invoices" element={<Invoices />} />
        <Route path="/cfo/invoices/:id" element={<InvoiceDetail />} />
      </Route>
    </Route>

    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default AppRoutes;
